var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Skeleton',{attrs:{"height":"48px"}}),_vm._v(" "),_c('div',{staticClass:"h-6"}),_vm._v(" "),_c('Skeleton',{attrs:{"count":8}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }